import React, { Component} from "react";
import {Spinner} from 'react-bootstrap'
import Img from 'react-image';

class ImageLoader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imageLink: props.imageLink,
      exists: false
    };

   // this.imageExists = this.imageExists.bind(this);
    //this.renderActions = this.renderActions.bind(this);
  }
  
  componentDidMount() {
  this.interval = setInterval(() => this.setState({ exists: this.imageExists() }), 10000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  imageExists()
  {
    var http = new XMLHttpRequest();
    http.open('HEAD', this.state.imageLink, false);
    http.send();
    return http.status!==404;
  }  

  render() {
    if (this.state.exists) {
     sessionStorage.setItem("fileName", "");
     sessionStorage.setItem("Term", "");
     sessionStorage.setItem("Width", "");
     sessionStorage.setItem("Height", "");
     sessionStorage.setItem("Repeat", "");
     sessionStorage.setItem("Blend", "");
     sessionStorage.setItem("Default", "");
      return (
      <Img src = {this.state.imageLink} />
      );
    } else {
      return (
      <Spinner animation="border" />
      );
    }
  }
}
export default ImageLoader;
